<script>
export default {
  name: 'DispatchItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatFullDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-MX', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
      });
    },
  },
};
</script>

<template>
<v-card outlined class="elevation-1 grey lighten-5 pa-4">
  <div class="d-flex justify-space-between align-start flex-wrap mb-4">

    <div class="d-flex flex-column align-start">
      <h3 class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1">
        Entrega #{{ item.visit_number }}
      </h3>

      <div class="text-caption grey--text text--darken-2
        d-flex align-center flex-wrap">
        <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
        {{ formatFullDate(item.dispatch_date) }} hrs.

        <span class="mx-2">&bull;</span>

        <v-icon small class="mr-1">mdi-store</v-icon>
        Sucursal: <strong class="ml-1">{{ item.dispatch_store_name || 'N/A' }}</strong>

        <span class="mx-2">&bull;</span>

        <v-icon small class="mr-1">mdi-account-tie</v-icon>
        Entrega: <strong class="ml-1">{{ item.employee_name }}</strong>
      </div>
    </div>

    <div class="d-flex flex-column align-end mt-2 mt-sm-0">
      <v-chip
        v-if="item.ine_validated"
        small
        color="success"
        dark
        class="font-weight-medium mb-1"
      >
        <v-icon left small>mdi-account-card-details-outline</v-icon>
        Identificación Validada
      </v-chip>

      <div class="text-caption grey--text text--darken-3">
        <span class="font-weight-bold grey--text text--darken-1">Documento:</span>
        <span class="text-uppercase ml-1">
          {{ item.identity_document_folio }}
        </span>
      </div>
    </div>

  </div>

  <div class="white pa-3 rounded border mb-2">
    <div class="text-caption font-weight-bold text-uppercase
      grey--text text--darken-1 mb-2">
      Artículos retirados en esta visita:
    </div>
    <ul class="pl-4 text-body-2">
      <li v-for="item in item.items" :key="item.product_id" class="mb-1">
        <strong>
          {{ item.quantity_delivered }} pz</strong> &times; {{ item.name }}
        <span class="grey--text text-caption">({{ item.sku }})</span>
      </li>
    </ul>
  </div>

  <div
    v-if="item.notes"
    class="bg-slate-50 pa-3 rounded border border-slate-200 text-body-2 mt-3"
  >
    <div class="d-flex align-center mb-1">
      <v-icon small color="grey darken-1" class="mr-2">
        mdi-message-text-outline
      </v-icon>
      <strong class="text-slate-700">Notas de entrega:</strong>
    </div>

    <div class="text-slate-600 font-italic pl-7">
      "{{ item.notes }}"
    </div>
  </div>
</v-card>
</template>
